"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentChangeTransition = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_2 = require("@headlessui/react");
const react_3 = require("react");
const constants_1 = require("../constants");
const Parent = styled_1.default.div `
  position: relative;
  transition: height ${constants_1.theme.animation.transition};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
let idCounter = 0;
/**
 * Transitions between sets of content smoothly by fading in/out the content
 * and animating the height change.
 */
const ContentChangeTransition = ({ children, transitionTrigger, }) => {
    const initialRender = (0, react_3.useRef)(true);
    const parentRef = (0, react_3.useRef)(null);
    const [height, setHeight] = (0, react_3.useState)('auto');
    const [childrenItem, setChildrenItem] = (0, react_3.useState)([
        {
            id: idCounter,
            children,
        },
    ]);
    const parentElement = parentRef.current;
    (0, react_3.useEffect)(() => {
        // Already contains the first childrenItem
        if (initialRender.current) {
            initialRender.current = false;
            return;
        }
        setChildrenItem((currentChildren) => [
            ...currentChildren,
            {
                id: ++idCounter,
                children,
            },
        ]);
        setTimeout(() => {
            setChildrenItem((currentChildren) => currentChildren.slice(1));
        }, constants_1.theme.animation.duration * 1000);
    }, [transitionTrigger]);
    (0, react_3.useEffect)(() => {
        if (childrenItem.length === 1 && parentElement) {
            setHeight('auto');
        }
    }, [childrenItem.length]);
    /*
      Not loving needing to get height on every render. But couldn't get a reliable value from
      Transition's beforeEnter or the other hooks
    */
    const fromHeight = parentElement
        ? getComputedStyle(parentElement).height
        : 'auto';
    return ((0, jsx_runtime_1.jsx)(Parent, { ref: parentRef, style: {
            overflow: childrenItem.length > 1 ? 'hidden' : '',
            height,
        }, children: (0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: ({ css }) => childrenItem.map(({ children, id }, index, arr) => ((0, jsx_runtime_1.jsx)(react_2.Transition, { ref: (node) => {
                    if (!node || !parentElement) {
                        return;
                    }
                    const toHeight = getComputedStyle(node).height;
                    setHeight(fromHeight);
                    requestAnimationFrame(() => {
                        setHeight(toHeight);
                    });
                }, className: css `
                /* If a child e.g. has margin-top, it will be included in the parent's height calculation */
                display: flow-root;
                top: 0;
                right: 0;
                left: 0;
              `, appear: index !== 0, show: index === arr.length - 1, leave: css `
                transition: opacity ${constants_1.theme.animation.transition};
              `, leaveFrom: css `
                opacity: 1;
              `, leaveTo: css `
                position: absolute;
                opacity: 0;
              `, enter: css `
                transition: opacity ${constants_1.theme.animation.transition};
              `, enterFrom: css `
                opacity: 0;
              `, enterTo: css `
                opacity: 1;
              `, children: children }, id))) }) }));
};
exports.ContentChangeTransition = ContentChangeTransition;
